import React, { FC, memo } from "react";

import { ITestable, testAttr } from "@/browser";

import { Flex } from "../../Flex";

export interface NoDataProps extends ITestable {
  text?: string;
}

const NoDataComponent: FC<NoDataProps> = props => {
  const { text = "No data" } = props;

  const testableProps = testAttr(props, { sufix: "data-table__no-data" });

  return (
    <Flex justify="center" padding={["xl"]} {...testableProps}>
      {text}
    </Flex>
  );
};

export const NoData = memo(NoDataComponent);
